import { usePushNotifications } from '../hooks/usePushNotifications';

export function NotificationBell() {
  const {
    isSupported,
    isSubscribed,
    isSubscribing,
    permission,
    subscribe,
    unsubscribe,
  } = usePushNotifications();

  // Not supported in this browser/mode
  if (!isSupported) {
    return (
      <button
        disabled
        title="Push notifications not supported (try installing the app to your home screen)"
        className="p-2 text-gray-300 cursor-not-allowed"
      >
        <BellIcon className="w-5 h-5" />
      </button>
    );
  }

  // Permission denied
  if (permission === 'denied') {
    return (
      <button
        disabled
        title="Notifications blocked - enable in browser settings"
        className="p-2 text-red-400 cursor-not-allowed"
      >
        <BellSlashIcon className="w-5 h-5" />
      </button>
    );
  }

  // Enabled
  if (isSubscribed) {
    return (
      <button
        onClick={unsubscribe}
        disabled={isSubscribing}
        title="Notifications enabled - click to disable"
        className="p-2 text-green-600 hover:text-green-700 transition-colors"
      >
        <BellIcon className="w-5 h-5 fill-current" />
      </button>
    );
  }

  // Disabled but can enable
  return (
    <button
      onClick={subscribe}
      disabled={isSubscribing}
      title="Notifications disabled - click to enable"
      className="p-2 text-gray-400 hover:text-gray-600 transition-colors"
    >
      <BellIcon className="w-5 h-5" />
    </button>
  );
}

// Simple bell icon SVG
function BellIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
      />
    </svg>
  );
}

// Bell with slash (for blocked)
function BellSlashIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9M3 3l18 18"
      />
    </svg>
  );
}
